<template>
  <div
    class="overlay"
    :class="{ zero: !isAuth }"
  >
    <!--<img src="/images/ring-loader.svg">-->
    <span class="loading-spinner" />
  </div>
</template>

<script>
    export default {
        name: "LoaderComponent",
        computed: {
            isAuth(){
                return this.$store.state.authenticated;
            }
        }
    }
</script>

<style lang="scss" scoped>
  .overlay{
    background-color: rgba(239, 239, 239, 0.4);

    .loading-spinner{
      border-left-color: transparent !important;
    }
  }
</style>